import {gql} from '@apollo/client';

export const GET_APPOINTMENT_PARCELS = gql`
  query GetAppointmentParcels($id: Long!) {
    getAppointmentParcels(id: $id) {
      id
      trackingNumber
      overallStatus
      createdAt
      deliverAt
      pickupScheduledDate  
    }
  }
`;

export interface ParcelItem {
    id: number;
    trackingNumber: string;
    overallStatus: string;
    createdAt: string;
    deliverAt: string;
    pickupScheduledDate: string;
}

export interface GetAppointmentParcelsResponse {
    getAppointmentParcels: ParcelItem[];
}

export interface GetAppointmentParcelsVariables {
    id: number;
}